/* ==========================================================================
   NS Strainfinder
   A step-by-step quiz modal. Every answer maps to a real Shopify storefront
   filter, so "Show results" simply lands the shopper on the collection page
   with those filters applied — no add-to-cart, no custom product rendering,
   so deals / bundle pricing / product cards all keep working as they do now.

   Config is read from <script type="application/json" id="NsStrainfinderConfig">
   rendered by snippets/ns-strainfinder.liquid.
   ========================================================================== */

(function () {
  'use strict';

  /* ---------------------------------------------------------------- icons */

  var ICONS = {
    search: '<circle cx="11" cy="11" r="6.5"/><path d="M20 20l-4.2-4.2"/>',
    check: '<path d="M4.5 12.5 9.5 17.5 19.5 7"/>',
    close: '<path d="M6 6l12 12M18 6 6 18"/>',
    restart: '<path d="M3 12a9 9 0 1 0 3-6.7"/><path d="M3 4.5V10h5.5"/>',
    left: '<path d="M19 12H5"/><path d="M11 6l-6 6 6 6"/>',
    right: '<path d="M5 12h14"/><path d="M13 6l6 6-6 6"/>',
    dots:
      '<circle cx="6" cy="12" r="1.6" fill="currentColor" stroke="none"/>' +
      '<circle cx="12" cy="12" r="1.6" fill="currentColor" stroke="none"/>' +
      '<circle cx="18" cy="12" r="1.6" fill="currentColor" stroke="none"/>',
    book:
      '<path d="M12 6.5v13"/>' +
      '<path d="M12 6.5C10.8 5.2 9 4.5 6.5 4.5H4v13h2.5c2.5 0 4.3.7 5.5 2"/>' +
      '<path d="M12 6.5c1.2-1.3 3-2 5.5-2H20v13h-2.5c-2.5 0-4.3.7-5.5 2"/>',
    cap:
      '<path d="M12 4 2.5 8.5 12 13l9.5-4.5z"/>' +
      '<path d="M6.5 10.7V16c0 1.7 2.5 3 5.5 3s5.5-1.3 5.5-3v-5.3"/>' +
      '<path d="M21.5 8.5v5.5"/>',
    venus: '<circle cx="12" cy="9" r="5"/><path d="M12 14v7"/><path d="M9 18h6"/>',
    bolt: '<path d="M13 2.5 4.5 13.5H11l-1 8 8.5-11H12z"/>',
    home:
      '<path d="M3 10.5 12 3.5l9 7"/><path d="M5.5 9.5V20.5h13V9.5"/><path d="M10 20.5V15h4v5.5"/>',
    sun:
      '<circle cx="12" cy="12" r="4"/>' +
      '<path d="M12 2v2M12 20v2M4.2 4.2l1.4 1.4M18.4 18.4l1.4 1.4M2 12h2M20 12h2M4.2 19.8l1.4-1.4M18.4 5.6l1.4-1.4"/>',
    snow:
      '<path d="M12 2v20M3.5 7 20.5 17M20.5 7 3.5 17"/>' +
      '<path d="M12 6l-2-2M12 6l2-2M12 18l-2 2M12 18l2 2"/>',
    greenhouse:
      '<path d="M4 21V9.5L12 4l8 5.5V21z"/><path d="M12 4.5V21"/><path d="M4 12h16"/><path d="M4 16.5h16"/>',
    up: '<path d="M12 20V5"/><path d="M6 11l6-6 6 6"/>',
    balance:
      '<path d="M12 4v16"/><path d="M5 8h14"/><path d="M8 8 5 14h6z"/><path d="M19 8l-3 6h6z"/><path d="M8.5 20h7"/>',
    moon: '<path d="M20.5 13.8A8.6 8.6 0 0 1 10.2 3.5a8.6 8.6 0 1 0 10.3 10.3z"/>',
    leaf:
      '<path d="M12 21c0-5.5 2.8-10.2 8-12.5-.8 5.8-3 9.8-8 12.5z"/>' +
      '<path d="M12 21c0-5.5-2.8-10.2-8-12.5.8 5.8 3 9.8 8 12.5z"/><path d="M12 21v-4.5"/>',
    flame:
      '<path d="M12 22c3.3 0 6-2.3 6-5.4 0-4.1-3.9-5.6-3.1-10.6C11.4 7.6 9.4 10 9.4 12c0 1.4-1.1 1.2-1.7.2-.8 1.2-1.7 2.6-1.7 4.4C6 19.7 8.7 22 12 22z"/>',
    size: '<path d="M12 3v18"/><path d="M8 7l4-4 4 4"/><path d="M8 17l4 4 4-4"/>',
    box: '<path d="M12 3 3.5 7.5v9L12 21l8.5-4.5v-9z"/><path d="M3.5 7.5 12 12l8.5-4.5"/><path d="M12 12v9"/>',
    citrus:
      '<circle cx="12" cy="12" r="9"/><path d="M12 3v18M3 12h18M5.6 5.6l12.8 12.8M18.4 5.6 5.6 18.4"/>',
    earth:
      '<path d="M2.5 18.5h19"/><path d="M4 18.5c1.5-4.5 4-7 8-7s6.5 2.5 8 7"/>' +
      '<path d="M9 14.5c.8-1 1.8-1.5 3-1.5s2.2.5 3 1.5"/>',
    flower:
      '<circle cx="12" cy="12" r="2.5"/>' +
      '<path d="M12 9.5c0-3 1-4.5 2.5-4.5S17 6.5 15.5 9"/>' +
      '<path d="M14.5 12c3 0 4.5 1 4.5 2.5S17.5 17 15 15.5"/>' +
      '<path d="M12 14.5c0 3-1 4.5-2.5 4.5S7 17.5 8.5 15"/>' +
      '<path d="M9.5 12c-3 0-4.5-1-4.5-2.5S6.5 7 9 8.5"/>',
    apple:
      '<path d="M12 8c-3.5-2.5-8 .5-8 5.5 0 3.5 2.5 7 4.5 7 1 0 2-.7 3.5-.7s2.5.7 3.5.7c2 0 4.5-3.5 4.5-7 0-5-4.5-8-8-5.5z"/>' +
      '<path d="M12 8V5"/><path d="M12 5c1.5-2 3.5-2 4.5-1.5"/>',
    tree: '<path d="M12 3 7 10h3l-4 6h5v5h2v-5h5l-4-6h3z"/>',
    candy:
      '<circle cx="12" cy="12" r="4"/><path d="M8.5 9.5 4 5v6l3 1"/><path d="M15.5 14.5 20 19v-6l-3-1"/>',
    droplet: '<path d="M12 3.5S5.5 10 5.5 14.2A6.5 6.5 0 0 0 18.5 14.2C18.5 10 12 3.5 12 3.5z"/>',
    berry:
      '<circle cx="9" cy="15" r="4"/><circle cx="15.5" cy="14" r="3.6"/>' +
      '<path d="M9 11V7"/><path d="M9 7c2.5 0 4-1.2 4.5-2.5"/>',
    cheese:
      '<path d="M3 17V12l9-5 9 5v5z"/><circle cx="8" cy="14.5" r="1"/>' +
      '<circle cx="13.5" cy="15" r="1"/><circle cx="17.5" cy="13.5" r="1"/>',
    waves:
      '<path d="M2 9c2-2 4-2 6 0s4 2 6 0 4-2 6 0"/>' +
      '<path d="M2 14c2-2 4-2 6 0s4 2 6 0 4-2 6 0"/>' +
      '<path d="M2 19c2-2 4-2 6 0s4 2 6 0 4-2 6 0"/>'
  };

  function icon(name, width) {
    var body = ICONS[name] || ICONS.dots;
    return (
      '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="' +
      (width || 1.7) +
      '" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" focusable="false">' +
      body +
      '</svg>'
    );
  }

  function esc(str) {
    return String(str == null ? '' : str)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;');
  }

  /* ----------------------------------------------------------------- core */

  function Strainfinder(root) {
    this.root = root;
    this.cfg = null;
    this.step = 0;
    this.answers = {};
    this.countAvailable = true;
    this.countTimer = null;
    this.countAbort = null;
    this.lastCount = null;
    this.lastFocus = null;

    var raw = document.getElementById('NsStrainfinderConfig');
    if (!raw) return;
    try {
      this.cfg = JSON.parse(raw.textContent);
    } catch (e) {
      return;
    }
    if (!this.cfg || !this.cfg.questions || !this.cfg.questions.length) return;

    this.storageKey = 'ns-strainfinder:' + (this.cfg.collectionUrl || 'default');
    this.el = {
      dialog: root.querySelector('[data-nssf-dialog]'),
      stepCount: root.querySelector('[data-nssf-stepcount]'),
      stepper: root.querySelector('[data-nssf-stepper]'),
      body: root.querySelector('[data-nssf-body]'),
      prev: root.querySelector('[data-nssf-prev]'),
      next: root.querySelector('[data-nssf-next]'),
      count: root.querySelector('[data-nssf-count]')
    };

    this.restore();
    this.bind();
    this.render();
  }

  Strainfinder.prototype.total = function () {
    return this.cfg.questions.length;
  };

  Strainfinder.prototype.current = function () {
    return this.cfg.questions[this.step];
  };

  /* ------------------------------------------------------------- storage */

  Strainfinder.prototype.restore = function () {
    if (!this.cfg.rememberAnswers) return;
    try {
      var saved = JSON.parse(sessionStorage.getItem(this.storageKey) || 'null');
      if (saved && saved.answers) {
        this.answers = saved.answers;
        this.step = Math.min(saved.step || 0, this.total() - 1);
      }
    } catch (e) {
      /* ignore */
    }
  };

  Strainfinder.prototype.persist = function () {
    if (!this.cfg.rememberAnswers) return;
    try {
      sessionStorage.setItem(
        this.storageKey,
        JSON.stringify({ answers: this.answers, step: this.step })
      );
    } catch (e) {
      /* ignore */
    }
  };

  /* --------------------------------------------------------------- state */

  Strainfinder.prototype.selected = function (qid) {
    return this.answers[qid] || [];
  };

  Strainfinder.prototype.isAnswered = function (index) {
    var q = this.cfg.questions[index];
    return q ? this.selected(q.id).length > 0 : false;
  };

  Strainfinder.prototype.toggle = function (optIndex) {
    var q = this.current();
    var opt = q.options[optIndex];
    var chosen = this.selected(q.id).slice();
    var pos = chosen.indexOf(optIndex);

    if (!q.multi) {
      chosen = pos === -1 ? [optIndex] : [];
    } else if (opt.none) {
      chosen = pos === -1 ? [optIndex] : [];
    } else {
      if (pos === -1) chosen.push(optIndex);
      else chosen.splice(pos, 1);
      // a real choice cancels "no preference"
      chosen = chosen.filter(function (i) {
        return !q.options[i].none;
      });
    }

    this.answers[q.id] = chosen;
    this.persist();
    this.render();

    if (this.cfg.autoAdvance && !q.multi && chosen.length && this.step < this.total() - 1) {
      var self = this;
      window.setTimeout(function () {
        self.go(self.step + 1);
      }, 240);
    }
  };

  Strainfinder.prototype.go = function (index) {
    this.step = Math.max(0, Math.min(index, this.total() - 1));
    this.persist();
    this.render();
    if (this.el.body) this.el.body.scrollTop = 0;
  };

  Strainfinder.prototype.reset = function () {
    this.answers = {};
    this.step = 0;
    this.persist();
    this.render();
  };

  /* ---------------------------------------------------------- url params */

  /**
   * Build the filter query string.
   * @param {number[]} [skip] question indexes to leave out (used when broadening)
   */
  Strainfinder.prototype.params = function (skip) {
    var params = new URLSearchParams();
    var seen = {};
    var self = this;
    var skipped = skip || [];

    this.cfg.questions.forEach(function (q, qi) {
      if (skipped.indexOf(qi) !== -1) return;
      self.selected(q.id).forEach(function (i) {
        var opt = q.options[i];
        if (!opt || !opt.filters) return;
        Object.keys(opt.filters).forEach(function (key) {
          opt.filters[key].forEach(function (val) {
            var dedupe = key + '=' + val;
            if (seen[dedupe]) return;
            seen[dedupe] = true;
            params.append(key, val);
          });
        });
      });
    });

    return params;
  };

  Strainfinder.prototype.resultsUrl = function () {
    var params = this.params();
    if (this.cfg.sortBy) params.set('sort_by', this.cfg.sortBy);
    var qs = params.toString();
    return this.cfg.collectionUrl + (qs ? '?' + qs : '');
  };

  /* ---------------------------------------------------------- live count */

  Strainfinder.prototype.scheduleCount = function () {
    if (!this.cfg.liveCount || !this.countAvailable || !this.el.count) return;
    var self = this;
    // The previous number is stale the moment an answer changes. Forget it so
    // the footer never blocks on a count that no longer describes the answers.
    this.lastCount = null;
    this.el.count.style.opacity = '0.45';
    window.clearTimeout(this.countTimer);
    this.countTimer = window.setTimeout(function () {
      self.fetchCount();
    }, 260);
  };

  Strainfinder.prototype.fetchCount = function () {
    var self = this;
    var params = this.params();
    params.set('view', this.cfg.countView || 'count');

    if (this.countAbort) this.countAbort.abort();
    this.countAbort = typeof AbortController !== 'undefined' ? new AbortController() : null;

    fetch(this.cfg.collectionUrl + '?' + params.toString(), {
      signal: this.countAbort ? this.countAbort.signal : undefined,
      headers: { 'X-Requested-With': 'XMLHttpRequest' }
    })
      .then(function (r) {
        if (!r.ok) throw new Error('bad status');
        return r.text();
      })
      .then(function (text) {
        var trimmed = text.trim();
        // The count template returns a bare number. Anything else means the
        // alternate template is missing — degrade quietly, never block.
        if (trimmed.length > 12 || !/^\d+$/.test(trimmed)) {
          self.countAvailable = false;
          self.paintCount(null);
          return;
        }
        self.lastCount = parseInt(trimmed, 10);
        self.paintCount(self.lastCount);
        self.paintFooter();
      })
      .catch(function (err) {
        if (err && err.name === 'AbortError') return;
        self.countAvailable = false;
        self.paintCount(null);
      });
  };

  Strainfinder.prototype.paintCount = function (n) {
    var box = this.el.count;
    if (!box) return;
    var t = this.cfg.labels || {};
    box.style.opacity = '';

    if (n === null || n === undefined) {
      box.textContent = '';
      box.className = 'nssf__count';
      return;
    }
    if (n === 0) {
      box.className = 'nssf__count nssf__count--empty';
      box.innerHTML = esc(t.noMatches || 'No strains match this combination — try changing an answer.');
      return;
    }
    box.className = 'nssf__count';
    box.innerHTML =
      '<b>' + n + '</b> ' + esc(n === 1 ? t.matchOne || 'strain matches' : t.matchMany || 'strains match');
  };

  /* -------------------------------------------------------------- render */

  Strainfinder.prototype.render = function () {
    this.paintStepCount();
    this.paintStepper();
    this.paintQuestion();
    this.paintFooter();
    this.scheduleCount();
  };

  Strainfinder.prototype.paintStepCount = function () {
    if (this.el.stepCount) {
      this.el.stepCount.textContent = this.step + 1 + ' / ' + this.total();
    }
  };

  Strainfinder.prototype.paintStepper = function () {
    if (!this.el.stepper) return;
    var html = '<span class="nssf__dot nssf__dot--done" aria-hidden="true">' + icon('search') + '</span>';
    var self = this;

    this.cfg.questions.forEach(function (q, i) {
      html += '<span class="nssf__bar"></span>';
      var cls = 'nssf__dot';
      var inner = String(i + 1);
      if (i === self.step) {
        cls += ' nssf__dot--current';
      } else if (self.isAnswered(i)) {
        cls += ' nssf__dot--done';
        inner = icon('check', 3);
      }
      // only let people jump to a step they've already reached
      var reachable = i <= self.step || self.isAnswered(i - 1);
      html +=
        '<button type="button" class="' +
        cls +
        '" data-nssf-goto="' +
        i +
        '"' +
        (reachable ? '' : ' disabled') +
        ' aria-label="' +
        esc((self.cfg.labels && self.cfg.labels.step ? self.cfg.labels.step : 'Question') + ' ' + (i + 1)) +
        '"' +
        (i === self.step ? ' aria-current="step"' : '') +
        '>' +
        inner +
        '</button>';
    });

    this.el.stepper.innerHTML = html;
  };

  Strainfinder.prototype.paintQuestion = function () {
    if (!this.el.body) return;
    var q = this.current();
    var chosen = this.selected(q.id);
    var hasDesc = q.options.some(function (o) {
      return !!o.desc;
    });
    var t = this.cfg.labels || {};

    var html = '<h3 class="nssf__question">' + esc(q.title) + '</h3>';
    var hint = q.hint || (q.multi ? t.multiHint : '');
    if (hint) html += '<p class="nssf__hint">' + esc(hint) + '</p>';

    html += '<div class="nssf__options' + (hasDesc ? '' : ' nssf__options--compact') + '">';

    q.options.forEach(function (opt, i) {
      var on = chosen.indexOf(i) !== -1;
      html +=
        '<button type="button" class="nssf__option' +
        (hasDesc ? '' : ' nssf__option--compact') +
        '" data-nssf-opt="' +
        i +
        '" aria-pressed="' +
        (on ? 'true' : 'false') +
        '">' +
        '<span class="nssf__check">' +
        icon('check', 3) +
        '</span>' +
        '<span class="nssf__option-head">' +
        '<span class="nssf__option-icon">' +
        icon(opt.icon || 'dots') +
        '</span>' +
        '<span class="nssf__option-label">' +
        esc(opt.label) +
        '</span>' +
        '</span>' +
        (opt.desc ? '<span class="nssf__option-desc">' + esc(opt.desc) + '</span>' : '') +
        '</button>';
    });

    html += '</div>';

    if (this.step === this.total() - 1) html += this.summaryHtml();

    this.el.body.innerHTML = html;
  };

  Strainfinder.prototype.summaryHtml = function () {
    var self = this;
    var t = this.cfg.labels || {};
    var pills = [];

    this.cfg.questions.forEach(function (q, qi) {
      self.selected(q.id).forEach(function (i) {
        var opt = q.options[i];
        if (!opt || opt.none) return;
        pills.push(
          '<li class="nssf__pill">' +
            esc(opt.label) +
            '<button type="button" data-nssf-clear="' +
            qi +
            ':' +
            i +
            '" aria-label="' +
            esc((t.remove || 'Remove') + ' ' + opt.label) +
            '">' +
            icon('close', 2.4) +
            '</button>' +
            '</li>'
        );
      });
    });

    if (!pills.length) return '';

    return (
      '<div class="nssf__summary">' +
      '<p class="nssf__summary-title">' +
      esc(t.yourChoices || 'Your choices') +
      '</p>' +
      '<ul class="nssf__pills">' +
      pills.join('') +
      '</ul></div>'
    );
  };

  Strainfinder.prototype.paintFooter = function () {
    var t = this.cfg.labels || {};
    var last = this.step === this.total() - 1;
    var answered = this.isAnswered(this.step);

    if (this.el.prev) this.el.prev.disabled = this.step === 0;

    if (this.el.next) {
      // A zero-result combination is never a dead end: the button turns into
      // "show closest matches", which drops the narrowest answers until
      // something comes back.
      var empty = last && this.countAvailable && this.lastCount === 0;
      var label = last
        ? empty
          ? t.broaden || 'Show closest matches'
          : t.showResults || 'Show results'
        : t.next || 'Next question';

      this.el.next.innerHTML = '<span>' + esc(label) + '</span>' + icon('right');
      this.el.next.disabled = !answered;
      this.el.next.setAttribute('data-nssf-mode', empty ? 'broaden' : last ? 'submit' : 'next');
    }
  };

  /* --------------------------------------------------------------- modal */

  Strainfinder.prototype.open = function () {
    this.lastFocus = document.activeElement;
    this.root.classList.add('is-open');
    this.root.removeAttribute('aria-hidden');
    document.body.classList.add('nssf-locked');
    this.render();
    var focusTarget = this.root.querySelector('.nssf__option') || this.el.dialog;
    if (focusTarget) focusTarget.focus();
  };

  Strainfinder.prototype.close = function () {
    this.root.classList.remove('is-open');
    this.root.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('nssf-locked');
    if (this.countAbort) this.countAbort.abort();
    if (this.lastFocus && this.lastFocus.focus) this.lastFocus.focus();
    if (location.hash === '#strainfinder') {
      history.replaceState(null, '', location.pathname + location.search);
    }
  };

  Strainfinder.prototype.isOpen = function () {
    return this.root.classList.contains('is-open');
  };

  Strainfinder.prototype.submit = function () {
    window.location.href = this.resultsUrl();
  };

  /**
   * Nothing matched. Drop answers from the last question backwards — the quiz
   * runs broad to narrow, so the tail questions are the cheapest to give up —
   * until the collection returns at least one product, then go there.
   */
  Strainfinder.prototype.broaden = function () {
    var self = this;
    var t = this.cfg.labels || {};
    var remaining = this.cfg.questions.map(function (q, i) {
      return i;
    });
    remaining.reverse();
    var dropped = [];

    if (this.el.next) {
      this.el.next.disabled = true;
      this.el.next.innerHTML = '<span>' + esc(t.searching || 'Looking for the closest match…') + '</span>';
    }

    function land(params) {
      if (self.cfg.sortBy) params.set('sort_by', self.cfg.sortBy);
      var qs = params.toString();
      window.location.href = self.cfg.collectionUrl + (qs ? '?' + qs : '');
    }

    function attempt() {
      if (!remaining.length) return land(new URLSearchParams());
      dropped.push(remaining.shift());

      var params = self.params(dropped);
      if (!params.toString()) return land(params);

      var probe = new URLSearchParams(params.toString());
      probe.set('view', self.cfg.countView || 'count');

      fetch(self.cfg.collectionUrl + '?' + probe.toString(), {
        headers: { 'X-Requested-With': 'XMLHttpRequest' }
      })
        .then(function (r) {
          return r.text();
        })
        .then(function (text) {
          var n = parseInt(text.trim(), 10);
          if (isNaN(n)) return land(params);
          if (n > 0) return land(params);
          attempt();
        })
        .catch(function () {
          land(params);
        });
    }

    attempt();
  };

  Strainfinder.prototype.trapFocus = function (event) {
    var focusables = this.root.querySelectorAll(
      'button:not([disabled]), [href], input, select, textarea, [tabindex]:not([tabindex="-1"])'
    );
    if (!focusables.length) return;
    var first = focusables[0];
    var lastEl = focusables[focusables.length - 1];

    if (event.shiftKey && document.activeElement === first) {
      event.preventDefault();
      lastEl.focus();
    } else if (!event.shiftKey && document.activeElement === lastEl) {
      event.preventDefault();
      first.focus();
    }
  };

  /* --------------------------------------------------------------- bind */

  Strainfinder.prototype.bind = function () {
    var self = this;

    this.root.addEventListener('click', function (event) {
      var el = event.target.closest('[data-nssf-close], [data-nssf-restart], [data-nssf-prev], [data-nssf-next], [data-nssf-opt], [data-nssf-goto], [data-nssf-clear]');
      if (!el) return;

      if (el.hasAttribute('data-nssf-close')) return self.close();
      if (el.hasAttribute('data-nssf-restart')) return self.reset();
      if (el.hasAttribute('data-nssf-prev')) return self.go(self.step - 1);

      if (el.hasAttribute('data-nssf-next')) {
        var mode = el.getAttribute('data-nssf-mode');
        if (mode === 'broaden') return self.broaden();
        if (mode === 'submit') return self.submit();
        return self.go(self.step + 1);
      }

      if (el.hasAttribute('data-nssf-opt')) {
        return self.toggle(parseInt(el.getAttribute('data-nssf-opt'), 10));
      }

      if (el.hasAttribute('data-nssf-goto')) {
        return self.go(parseInt(el.getAttribute('data-nssf-goto'), 10));
      }

      if (el.hasAttribute('data-nssf-clear')) {
        var parts = el.getAttribute('data-nssf-clear').split(':');
        var q = self.cfg.questions[parseInt(parts[0], 10)];
        var optIndex = parseInt(parts[1], 10);
        self.answers[q.id] = self.selected(q.id).filter(function (i) {
          return i !== optIndex;
        });
        self.persist();
        self.render();
      }
    });

    document.addEventListener('keydown', function (event) {
      if (!self.isOpen()) return;
      if (event.key === 'Escape') {
        event.preventDefault();
        self.close();
      } else if (event.key === 'Tab') {
        self.trapFocus(event);
      }
    });
  };

  /* ---------------------------------------------------------------- boot */

  function boot() {
    var root = document.querySelector('[data-nssf-root]');
    if (!root) return;

    var instance = new Strainfinder(root);
    if (!instance.cfg) return;

    window.NsStrainfinder = {
      open: instance.open.bind(instance),
      close: instance.close.bind(instance),
      reset: instance.reset.bind(instance),
      instance: instance
    };

    document.addEventListener('click', function (event) {
      var trigger = event.target.closest(
        '[data-strainfinder-open], .js-strainfinder-open, a[href="#strainfinder"], a[href$="#strainfinder"]'
      );
      if (!trigger || root.contains(trigger)) return;
      event.preventDefault();
      instance.open();
    });

    if (location.hash === '#strainfinder') instance.open();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
